import { render } from "./WCCustomizeButtonMobile.vue?vue&type=template&id=3383ec50"
import script from "./WCCustomizeButtonMobile.vue?vue&type=script&lang=js"
export * from "./WCCustomizeButtonMobile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__